<div class="standard-max-width">
  <div class="flex align-items-center justify-content-between mb-6 mt-2">
    <div class="flex align-items-center">
      <i class="material-icons text-2xl mr-2">groups</i>
      <span class="text-2xl font-semibold">Manage Patients</span>
    </div>
    <div class="flex gap-2">
      <button pButton type="button" icon="pi pi-plus" label="Add Patient" class="p-button-primary"
        (click)="openAddPatientDialog()"></button>
    </div>
  </div>

  <hr class="my-4">

  <app-patients-view [orgId]="orgId" #patientsView />
</div>

<p-dialog header="Add Patient" [(visible)]="showAddPatientDialog" [modal]="true"
  [style]="{ maxWidth: '40vw', minHeight: '60vh'}" [draggable]="false" [resizable]="false"
  (onHide)="closeAddPatientDialog()">
  <app-crud-patient *ngIf="showAddPatientDialog" [orgId]="orgId" (onSubmit)="onPatientAdded()" />
</p-dialog>